import createConverter from './lib/create_converter';
import CompanyProfile from 'models/company_profile';

export default createConverter(CompanyProfile);
